import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './GuestLogin.css';
import { useLanguage } from '../../context/LanguageContext';

function GuestLogin({ onLogin }) {
  const { t } = useLanguage();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const API_URL = window.location.hostname === 'localhost' ? "http://localhost:5001" : "https://esponjoboda.com";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API_URL}/api/guest-login`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        },
        body: JSON.stringify({ code: code.toUpperCase() })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Error');

      // Handle production vs local response structure mismatch
      // Production: { ok: true, found: { name, allowedGuests, ... } }
      // Local: { name, allowedGuests, ... }
      const guestData = data.found ? data.found : data;

      onLogin({ ...guestData, code });
      navigate('/rsvp-invitado');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="guest-login-container">
      <form className="guest-login-form" onSubmit={handleSubmit}>
        <h2>{t.rsvp_login_title}</h2>
        <label htmlFor="code">{t.rsvp_login_code}</label>
        <input
          id="code"
          type="text"
          value={code}
          onChange={e => setCode(e.target.value)}
          placeholder={t.rsvp_login_placeholder}
          required
        />
        <button type="submit" disabled={loading}>{loading ? t.rsvp_login_wait : t.rsvp_login_button}</button>
        {error && <div className="error-message">{error}</div>}
      </form>
    </div>
  );
}

export default GuestLogin;
